const o = "capital-support@adyen.com";
export {
  o as SUMMARY_TEXT_EMAIL
};
